import { Divider, DividerProps } from "@blueprintjs/core";
import styled from "styled-components";

export interface HexDividerProps extends DividerProps {
  $muted?: boolean;
}

export const HexDivider = styled(Divider)<HexDividerProps>`
  border-color: ${({ $muted, theme }) =>
    $muted ? theme.borderColor.MUTED : theme.borderColor.DEFAULT};
`;
